import installer from './defaults'
export * from '@tni-plus/components'
export * from '@tni-plus/hooks'
export * from '@tni-plus/constants'
export * from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer
